import { memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { BzCard } from "../../components";
import { getIndexSectorList, getNearestBookValue, getPremiumDiscountData, getScreenersGridData, setArrActiveScreenerData, setBIsGridDataShow, setObjselectedScreener, setPrevScanner, setSelectedCategory } from "../../redux/actions/screeners";
import { SCREENER_REF } from "../../utils/global_functions";
import { DASHBOARD_EXPLORE_CATEGORY, LOCATIONS, SCREENERS_TABS } from "../../utils/global_variables";
import ZeroStates from "../ZeroStates";
// import Image from "../../assets/icons/screeners/scanners-spread.svg";


const pageNo = 1;
const pageSize = 10;


const ScreenersCards = ({ setIsExpandCollapse,isExpanded, setNActiveCategory, arrFilterForScanerPrev, setArrFilterForScannerPrev }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const selectedTab = useSelector(state => state.screeners.selectedTab);
    const arrActiveScannerData = useSelector(state => state.screeners.arrActiveScannerData);
    const arrIndexSectorList = useSelector(state => state.screeners.arrIndexSectorList);


    const handleClickonCard = (each) => {
        // Hari k: 09-04-24: BT-109095: Stategy and scanner logic added :start
        if (each?.GroupId === 38 || each?.GroupId === 39) {
            dispatch(getPremiumDiscountData({ statusMode: each.GroupName, pageNo: pageNo, pageSize: pageSize }));
        }
        if (each?.GroupId === 48) {
            dispatch(getNearestBookValue({ pageSize: 10, jtenantToken: 1 }));
        }
        if (location?.pathname === LOCATIONS.DASHBOARD) {
            dispatch(getScreenersGridData([{ RedisKeyPrefix: each.RedisKeyPrefix_1, segmentId: 1, indexSector: 'All', month: "-" }, { RedisKeyPrefix: each.RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
        }
        // Hari k: 09-04-24: BT-109095: Stategy and scanner logic added :end

        dispatch(setBIsGridDataShow(true));
        arrIndexSectorList?.length < 1 && dispatch(getIndexSectorList());
        //Vaibhav S: 15-01-24: BT-109095: Dispatch for selectObject start  : Start
        dispatch(setObjselectedScreener(each));
        //Vaibhav S: 15-01-24: BT-109095: Dispatch for selectObject start  : End
        if (location.pathname === LOCATIONS.DASHBOARD) {
            setIsExpandCollapse(true);
            setNActiveCategory(DASHBOARD_EXPLORE_CATEGORY.SCREENERS);
            dispatch(setArrActiveScreenerData([each]));
            dispatch(setSelectedCategory(each?.Category));
            if (selectedTab === SCREENERS_TABS.SCANNERS) {
                dispatch(setPrevScanner(each));
            }
            if (selectedTab === SCREENERS_TABS.MY_FAVOURITES) {
                dispatch(setPrevScanner(null));
            }
        }
        else {
            setIsExpandCollapse(true);
            if (selectedTab === SCREENERS_TABS.SCANNERS) {
                dispatch(setPrevScanner(each));
            }
            if (selectedTab === SCREENERS_TABS.MY_FAVOURITES) {
                dispatch(setPrevScanner(null));
            }
        }

    }

    //Vaibhav Singh: 06-03-24:ZeroStates added: Start
    return (
        <>
            {(location?.pathname === LOCATIONS.DASHBOARD) ?
                <div ref={SCREENER_REF} className='p-0'>
                    <Container fluid className='p-0 mt-3' >
                        <Row className='g-0 screeners-cards-grid'>
                            {/*K hari:10-09-2024: currently we are not showing advance and decline screeners as per BA discussion */}
                            {arrActiveScannerData?.length > 0 ? arrActiveScannerData?.filter(item => item.GroupId !== 40 && item.GroupId !== 41)?.map((each, i) => {

                                return (
                                    <Col key={i} className='d-flex justify-content-start align-self-center'>
                                        <BzCard data-testid={`screenersCard`} className='py-2' onClick={handleClickonCard?.bind(this, each)}>
                                            <div className='d-flex justify-content-start align-items-center cursor-pointer gap-2'>
                                                <div className='screeners-image'>
                                                    <div className={`${each?.ImagePath} icon-36`}></div>
                                                </div>
                                                <div className='screeners-title-text'>{each?.GroupName?.split(' ')?.map(word => word?.substring(0, 1)?.toUpperCase() + word?.substring(1)).join(' ')}
                                                </div>
                                            </div>
                                        </BzCard>
                                    </Col>
                                );
                            }) :

                                selectedTab === SCREENERS_TABS.MY_FAVOURITES ?
                                    <div className='zero-state-alerts zero-state-alerts-lg'>
                                        <ZeroStates heading="Currently you've no saved favourites!" icon='icon-64 icon-nodata mb-3 mrgauto' />

                                        <Container fluid className='mt-5 p-0'>
                                            <Row className='g-0'>
                                                <Col md={5} className='mrgauto'>
                                                    <Container fluid className='p-0'>
                                                        <Row className='g-0'>
                                                            <Col className='d-flex justify-content-center align-items-start'>
                                                                <div className='font-regular font-size5 color-text'>* You can save upto 9 screeners</div>
                                                            </Col>
                                                        </Row>
                                                        <Row className='g-0 mt-3'>
                                                            <Col>
                                                                <div className='steps-wrapper'>
                                                                    <div className='stepcount'>1</div>
                                                                    <div className='linewrapper'></div>
                                                                    <div className='stepcount'>2</div>
                                                                    <div className='linewrapper'></div>
                                                                    <div className='stepcount'>3</div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row className='g-0 mt-2'>
                                                            <Col className='d-flex justify-content-center align-items-start'>
                                                                <div className='font-regular font-size1 color-text text-center'>Go to 'Strategy' or<br />'Scanners' tab</div>
                                                            </Col>
                                                            <Col className='d-flex justify-content-center align-items-start'>
                                                                <div className='font-regular font-size1 color-text text-center'>Select the Screener<br />&amp; click on 3 dot<br />menu <span className='icon-12 icon-kebab icon-dark'></span></div>
                                                            </Col>
                                                            <Col className='d-flex justify-content-center align-items-start'>
                                                                <div className='font-regular font-size1 color-text text-center'>Select <span className='font-medium'>Add to favourites</span><br />to mark favourite</div>
                                                            </Col>
                                                        </Row>
                                                    </Container>
                                                </Col>
                                            </Row>
                                        </Container>

                                    </div>
                                    :
                                    <div className='zero-state-alerts zero-state-alerts-md'>
                                        <ZeroStates subText="No Data Found" icon='icon-64 icon-nodata mb-3 mrgauto' />
                                    </div>
                            }


                        </Row>
                    </Container>
                </div>
                :

                //Watchlist Side tray
                <div ref={SCREENER_REF}>
                    <div className={`${arrActiveScannerData?.length ? 'sticky-screeners-height' : ''} p-2`}>
                        <Container fluid className='p-0'>
                            <Row className={`g-0 ${isExpanded?.isTrue ? 'screeners-cards-grid':'screeners-cards-grid-half'}`}>
                                {arrActiveScannerData?.length > 0 ? arrActiveScannerData?.filter(item => item.GroupId !== 40 && item.GroupId !== 41)?.map((each, i) => {
                                    return (
                                        <Col key={i}>
                                            <BzCard  onClick={handleClickonCard?.bind(this, each)}>
                                                <div className='d-flex justify-content-start align-items-center cursor-pointer gap-2'>
                                                    <div className='screeners-image'>
                                                        <div className={`${each?.ImagePath} icon-36`}></div>
                                                    </div>
                                                    <div className='screeners-title-text'>{each?.GroupName?.split(' ')?.map(word => word?.substring(0, 1)?.toUpperCase() + word?.substring(1)).join(' ')}</div>
                                                </div>
                                            </BzCard>
                                        </Col>
                                    );
                                }) :
                                    selectedTab === SCREENERS_TABS.MY_FAVOURITES ?
                                        <div className='zero-state-alerts zero-state-alerts-xl'>
                                            <ZeroStates heading="Currently you've no saved favourites!" icon='icon-64 icon-nodata mb-3 mrgauto' />
                                            <Container fluid className='mt-5 p-0'>
                                                <Row className='g-0'>
                                                    <Col className='mrgauto'>
                                                        <Container fluid className='p-0'>
                                                            <Row className='g-0'>
                                                                <Col className='d-flex justify-content-center align-items-start'>
                                                                    <div className='font-regular font-size5 color-text'>* You can save upto 9 screeners</div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='g-0 mt-3'>
                                                                <Col>
                                                                    <div className='steps-wrapper'>
                                                                        <div className='stepcount'>1</div>
                                                                        <div className='linewrapper'></div>
                                                                        <div className='stepcount'>2</div>
                                                                        <div className='linewrapper'></div>
                                                                        <div className='stepcount'>3</div>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='g-0 mt-2'>
                                                                <Col className='d-flex justify-content-center align-items-start'>
                                                                    <div className='font-regular font-size1 color-text text-center'>Go to 'Strategy' or<br />'Scanners' tab</div>
                                                                </Col>
                                                                <Col className='d-flex justify-content-center align-items-start'>
                                                                    <div className='font-regular font-size1 color-text text-center'>Select the Screener<br />&amp; click on 3 dot<br />menu <span className='icon-12 icon-kebab icon-dark'></span></div>
                                                                </Col>
                                                                <Col className='d-flex justify-content-center align-items-start'>
                                                                    <div className='font-regular font-size1 color-text text-center'>Select <span className='font-medium'>Add to favourites</span><br />to mark favourite</div>
                                                                </Col>
                                                            </Row>
                                                        </Container>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </div>
                                        :
                                        <div className='zero-state-alerts zero-state-alerts-md'>
                                            <ZeroStates subText="No Data Found" icon='icon-64 icon-nodata mb-3 mrgauto' />
                                        </div>
                                }
                            </Row>
                        </Container>
                    </div>
                </div>
            }
        </>
    );
};
//Vaibhav Singh: 06-03-24:ZeroStates added: End
export default memo(ScreenersCards);